




















































import { Component, Prop, Ref } from "vue-property-decorator";
import { BaseComponent } from "@/app/BaseComponent";
import { LvBadge, LvButton, LvControlPopover, LvIcon } from "@fastoche/ui-kit/components";
import { AccommodationType } from "@/modules/listing/domain";
import { ListingFilterContext } from "@/modules/listing/context/ListingFilterContext";

export const COMPONENT_NAME = "ListingAccommodationTypeFilter";

@Component({
    name: COMPONENT_NAME,
    components: {
        LvControlPopover,
        LvButton,
        LvBadge,
        LvIcon
    },
})
export default class ListingAccommodationTypeFilter extends BaseComponent {
    @Prop({ type: Object, required: true })
    readonly filters!: ListingFilterContext;

    @Ref()
    readonly popover!: LvControlPopover;

    get hasValue() {
        return this.filters.type != undefined;
    }

    set(type: AccommodationType) {
        this.filters.type = type;
    }

    isSelected(type: AccommodationType) {
        return this.filters.type == type;
    }

    show() {
        this.popover.show();
    }

    hide() {
        this.popover.hide();
    }
}
